import { formatNum, request, useCurrentUserId } from '@/utils';
import { OfficialBadge } from '../types';
import { useQuery } from 'react-query';
import { useCallback } from 'react';
import { transBadge } from '../utils';
import { useLocation } from 'react-router-dom';

export const useIsOfficialBadge = () => {
  const location = useLocation<{ isOfficial?: boolean }>();
  return /\/official-badge\/(\d+)/.test(location.pathname);
};

type OfficialBadgesRes = {
  total_count: number;
  _totalCount: string;
  badge_list: OfficialBadge[];
};

export const useUserOfficialBadges = (userId: string) => {
  const url = '/user/official_badge_list';

  const select = useCallback((res: OfficialBadgesRes) => {
    res._totalCount = formatNum(res.total_count, 0);

    return res;
  }, []);

  return useQuery([url, userId], () => request.get<OfficialBadgesRes>(url, { id: userId }), {
    select,
  });
};

export const useOfficialBadgeList = (officialId: string) => {
  const currentAddress = useCurrentUserId();
  const url = '/official_badge/list';

  const select = useCallback(
    ({ badge_list }: { badge_list: Array<OfficialBadge & { has_minted: boolean }> }) => {
      badge_list.forEach(transBadge);

      return badge_list;
    },
    [],
  );

  return useQuery(
    [url, currentAddress, officialId],
    () =>
      request.get<{ badge_list: Array<OfficialBadge & { has_minted: boolean }> }>(url, {
        official_id: officialId,
      }),
    {
      select,
      enabled: !!officialId,
    },
  );
};
